// extracted by mini-css-extract-plugin
export default {"actions":"TagSelector_actions__2RiJq","all":"TagSelector_all__FclHa","selected":"TagSelector_selected__afo6I","form":"TagSelector_form__mhoPo"};